import { format, parseISO, toDate } from 'date-fns'


/***
 ** If value is of type Date, we expect it to be a valid date.
 ** API expects dates according to Y-m-dTH:i:sP format, where P is the timezone difference compared to UTC ( e.g. +0100).
 *  @param value of type string, Date, or number
 *  @param formatSymbolString defaults to `yyyy-MM-dd'T'00:00:00xxxx`. See https://date-fns.org/v2.9.0/docs/format for symbols.
 * @return formatted datestring with time at 00:00:00
 **/
export function convertToISO_8601_String (value, formatSymbolString?: string) {
  /*
  in resulting patterns the letter Z is removed because the API is not 100% compliant with ISO spec, and instead replaced with +0000 to indicate UTC +0
   */
  if (typeof value === 'string') {
    const dashified = value.replace(new RegExp('/', 'gi'), '-')
    return format(parseISO(dashified), formatSymbolString || `yyyy-MM-dd'T'00:00:00xxxx`).replace(new RegExp('Z', 'gi'), '+0000')
  }
  else if (typeof value === 'number') {
    return format(toDate(value), formatSymbolString || `yyyy-MM-dd'T'00:00:00xxxx`).replace(new RegExp('Z', 'gi'), '+0000')
  }
  else if (value instanceof Date && typeof value.getMonth === 'function') {
    return format(value, formatSymbolString || `yyyy-MM-dd'T'00:00:00xxxx`).replace(new RegExp('Z', 'gi'), '+0000')
  }
  else throw new Error('convertDateFormatsToDatestring: wrong input format')
}
